(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/react/components/hero/hero-text.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/react/components/hero/hero-text.js');

'use strict';

const HeroText = _ref => {
  let {
    title,
    body
  } = _ref;
  if (!title && !body) {
    return null;
  }
  return React.createElement("div", {
    className: "gp-hero-text"
  }, title && React.createElement("h2", null, title), body && React.createElement("p", null, body));
};
svs.gamePackage.components.HeroText = HeroText;

 })(window);